var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"history"},[_c('div',{staticClass:"history__sidebar"},[_c('Sidebar')],1),_c('div',{staticClass:"history__content"},[_c('h1',{staticClass:"history__content__tittle"},[_vm._v("History")]),_c('hr',{staticClass:"history__content__separator"}),_c('div',{staticClass:"history__content__container"},[_c('Table')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }